// extracted by mini-css-extract-plugin
module.exports = {"RelationsWrapper":"DeviceRelations_RelationsWrapper__ILShL"};